import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { FeatureFlagSchema, ErrorResponseSchema } from './schemas';
const c = initContract();
export const flagsContract = c.router({
    list: {
        method: 'GET',
        path: '/flags',
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(FeatureFlagSchema),
            }),
            401: ErrorResponseSchema,
        },
        summary: 'List all feature flags',
    },
    toggle: {
        method: 'PATCH',
        path: '/flags/:flagId',
        pathParams: z.object({
            flagId: z.string(),
        }),
        body: z.object({
            enabled: z.boolean(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: FeatureFlagSchema,
            }),
            401: ErrorResponseSchema,
            404: ErrorResponseSchema,
        },
        summary: 'Toggle a feature flag',
    },
});
//# sourceMappingURL=flags.js.map